import {rgElement} from '../rgElement/rg-element.js'

/*
usage: <rg-qrcode data-content="blubb blah" data-format="svg" data-modulesize="5" data-margin="5"></rg-qrcode>
 */
const defaultAttributes = {
        'data-content': null,
        'data-format': 'svg',
        'data-modulesize': 5,
        'data-margin': 4
    },
    getOptions = function () {
        const {
            modulesize,
            margin,
            format
        } = this.dataset;
        return {
            modulesize: modulesize ? parseInt(modulesize) : defaultAttributes['data-modulesize'],
            margin: margin ? parseInt(margin) : defaultAttributes['data-margin'],
            format: format ? format : defaultAttributes['data-format'],
        }
    }
let apiReady = false,
    generating = false,
    QRCode = {};

export class rgQrcode extends rgElement {

    constructor() {
        super()
    }

    connectedCallback() {
        this.attachShadow({mode: 'open'});
        this.setUpElement();
        this.addEventListener('rg-qrcode:apiloaded', function (ev) {
            Object.assign(QRCode, ev.detail.defaultExport.default);
            apiReady = true;
            this.generate();
        }.bind(this));
        this.extendApi('/api/rg-qrcode-api.js');

        this.setupComplete();
    }

    static get observedAttributes() {
        return Object.keys(defaultAttributes)
    }

    // LifeCycle Callbacks
    attributeChangedCallback(attributeName, oldValue, newValue) {
        this.dispatchEvent(new CustomEvent(this.tagName.toLowerCase() + ':changed', {
            detail: {
                el: this,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue,
            }
        }));
        this.generate();
    }

    generate() {
        if (!apiReady || generating) {
            return;
        }
        generating = true;
        try {
            this.clear();
            if(!this.dataset.format) {
                this.dataset.format = 'svg';
            }
            if (this.dataset.content) {
                switch (this.dataset.format.toLowerCase()) {
                    case 'svg':
                    default:
                        this.generateSVG();
                        break;
                    case 'png':
                        this.generatePNG();
                        break;
                    case 'html':
                        this.generateHTML();
                        break;
                }
            } else {
                this.shadowRoot.textContent = 'qr-code: no data!'
            }
        } catch (e) {
            console.error(e);
            this.shadowRoot.textContent = 'qr-code: error!'
        }
        generating = false;
    }

    generatePNG() {
        const img = document.createElement('img')
        img.src = QRCode.generatePNG(this.dataset.content, getOptions.call(this))
        img.setAttribute('part', 'img')
        this.shadowRoot.appendChild(img)
    }

    generateHTML() {
        const div = QRCode.generateHTML(this.dataset.content, getOptions.call(this))
        const table = div.firstChild
        table.setAttribute('part', 'table')
        this.shadowRoot.appendChild(table)
    }

    generateSVG() {
        const svg = QRCode.generateSVG(this.dataset.content, getOptions.call(this))
        svg.setAttribute('part', 'svg')
        this.shadowRoot.appendChild(svg)
    }

    clear() {
        while (this.shadowRoot.lastChild) {
            this.shadowRoot.removeChild(this.shadowRoot.lastChild)
        }
    }
}